import ForexContainer from "./forex_container";
import TopService from "./top_service";
import { Sparklines, SparklinesLine } from 'react-sparklines';
import GatewayChart from "./gateway_chart";
import { GatewayStatsSummary } from "../../Payments/services";
import { usePaymentsStore } from "../../Payments/store/paymentsStore";
import { useCurrencyStore } from "../../Forex/store/currencyStore";
import { useEffect } from "react";

export default function OverviewAnalytics({ gatewayStats }: { gatewayStats: GatewayStatsSummary }) {

    const serviceStats = usePaymentsStore((state) => state.serviceStats);
    const { currencies, fetchCurrencies } = useCurrencyStore();

    useEffect(() => {
        fetchCurrencies();
    }, [fetchCurrencies]);

    return (
        <div className="grid grid-cols-4 grid-rows-3 h-[450px] gap-4 my-4">
            <div className="col-span-1 row-span-3 bg-card rounded-xl p-4">
                <div className="w-full flex flex-col items-center justify-center">
                    <p className="text-white text-xl font-semibold">Gateway Usage</p>

                    <div className="h-[250px] w-full rounded-xl my-4">
                        <GatewayChart gatewayStats={gatewayStats} />
                    </div>

                    <div className="w-full grid grid-cols-2 gap-x-2">
                        <div className="p-3">
                            <div className="w-fit flex items-center gap-x-2 text-black text-xs p-2 rounded-lg bg-white">
                                <div className="h-3 w-3 bg-airtel rounded-sm"></div>

                                Airtel
                            </div>
                        </div>
                        <div className="p-3">
                            <div className="w-fit flex items-center gap-x-2 text-black text-xs p-2 rounded-lg bg-white">
                                <div className="h-3 w-3 bg-paypal rounded-sm"></div>

                                PayPal
                            </div>
                        </div>
                        <div className="p-3">
                            <div className="w-fit flex items-center gap-x-2 text-black text-xs p-2 rounded-lg bg-white">
                                <div className="h-3 w-3 bg-mpamba rounded-sm"></div>

                                Mpamba
                            </div>
                        </div>
                        <div className="p-3">
                            <div className="w-fit flex items-center gap-x-2 text-black text-xs p-2 rounded-lg bg-white">
                                <div className="h-3 w-3 bg-stripe rounded-sm"></div>

                                Stripe
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div className="col-span-3 row-span-3">
                <div className="grid grid-rows-3 gap-4 h-full">
                    <div className="row-span-2 bg-card rounded-xl p-4">
                        <div className="w-full flex items-center justify-center mb-4">
                            <div></div>
                            <div className="flex items-center gap-x-2">
                                <p className="text-white text-lg font-medium">Top Services</p>
                            </div>
                            {/* <div className="flex items-center p-2 bg-[#1c1c1c] shadow-xl rounded-xl">
                                <button className="text-white px-4 py-1 rounded-lg text-sm">Daily</button>
                                <button className="text-white px-4 py-1 rounded-lg text-sm">Weekly</button>
                                <button className="bg-white text-black px-4 py-1 rounded-lg text-sm">Monthly</button>
                                <button className="text-white px-4 py-1 rounded-lg text-sm">Yearly</button>
                            </div> */}
                        </div>
                        <div className="w-full h-[200px] flex items-center justify-between rounded-xl">
                            <div className="w-full h-[200px] flex items-center justify-between rounded-xl">
                                {Object.entries(serviceStats)
                                    .sort(([, a], [, b]) => b.percentage - a.percentage)
                                    .slice(0, 4) // top 4 services
                                    .map(([serviceName, stats]) => {
                                        const safeName = serviceName.toLowerCase().replace(/\s+/g, '-'); // for CSS classes and file paths
                                        return (
                                            <TopService
                                                key={serviceName}
                                                imageSrc={`/images/${safeName}.png`}
                                                percentage={`${stats.percentage}%`}
                                                borderColor={`border-${safeName}`}
                                                name={serviceName}
                                                backgroundColor={safeName}
                                                color={stats.color} 
                                                value={stats.percentage}
                                            />
                                        );
                                    })}
                            </div>

                        </div>
                    </div>
                    <div className="row-span-1 bg-card rounded-xl p-4">
                        <div className="flex flex-col items-center justify-start h-full">
                            <p className="text-white text-lg font-medium">Forex Rates</p>
                            <div className="w-full flex items-center justify-between">
                                {currencies.map(currency => (
                                    <ForexContainer
                                        key={currency.currency}
                                        pair={`MWK/${currency.currency}`}
                                        percentage="+1.2"
                                        value={currency.rate}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}